import { createContext, useContext, type ReactNode } from 'react';
import type { ViewportTier } from '../app/responsive';

// Shell context: what every screen-level TopBar needs to know about the chrome around it.
//   phone / tabletMini → the screen's TopBar IS the app bar (title · status pill · avatar);
//   tablet            → AppShell renders the global bar (04–06), so a screen's TopBar renders
//                       as a pane header instead (title + subtitle + actions, no avatar).
// Provided by src/app/AppShell.tsx; the default lets components render standalone in tests.
export interface ShellContextValue {
  tier: ViewportTier;
  // The avatar entry: opens Settings › 验屋师资料, where the photo shown in the avatar is set (Owner
  // 2026-09-14); account, language and sign-out stay one Back away on the Settings root. There is no
  // global drawer and no per-page language switch (task book §3 / §19).
  openAccount: () => void;
  // The inspector's avatar node (photo / initials), composed by AppShell from the device profile;
  // null = the plain person glyph (components rendered standalone in tests).
  avatar: ReactNode;
  // The real offline / local / sync status chip for the top bar (Authority §13.3, D-10).
  statusChip: ReactNode;
}

export const ShellContext = createContext<ShellContextValue>({
  tier: 'phone',
  openAccount: () => undefined,
  statusChip: null,
  avatar: null
});

export function useShell(): ShellContextValue {
  return useContext(ShellContext);
}
